import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-col"
};
const _hoisted_2 = {
  class: "flex items-center"
};
import Player from "@/modules/team/components/Player.vue";
import Icon from "@/modules/vue/components/Icon.vue";
import PlayerList from "@/modules/team/components/PlayerList.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'MatchPlayerList',
  props: {
    team: null,
    suspendedPlayerIds: null
  },
  setup(__props) {
    const props = __props;
    const players = computed(() => collect(props.team.players).filter(p => p.lineup !== null).sortBy('lineup'));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(PlayerList, {
        players: _unref(players)
      }, {
        player: _withCtx(({
          player
        }) => [_createElementVNode("div", _hoisted_2, [_createVNode(Player, {
          player: player,
          "no-link": "",
          "hide-constitution": ""
        }, null, 8, ["player"]), __props.suspendedPlayerIds.includes(player.id) ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          icon: _ctx.IconEnum.Ban,
          size: "1rem",
          class: "text-red-600 ml-1"
        }, null, 8, ["icon"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["players"])]);
    };
  }
});